import { ExportType } from "../envConfig";

import {
  DID_YOU_KNOW_DIALOG_NAME,
  exportTypes,
  LS_EXPORT_BTN_ACTIVE,
  LS_EXPORT_FORMAT,
  LS_EXPORT_QR_CODE,
  LS_EXPORT_TYPE,
  LS_GEOLOCATION_ACTIVE,
  LS_HIDE_DID_YOU_KNOW,
  LS_ROUTING_MOT,
} from "./constants";

import type { RoutingMot } from "mobility-toolbox-js/types";

import type { GraphhopperRoutingProfile } from "../components/Editor/GraphhopperRoutingControl";

export default function getEnvFromStorage(): {
  dialogVisible: false | string;
  exportBtnActive?: boolean;
  exportFormat: string;
  exportQrCode?: number;
  exportType?: ExportType;
  geolocationActive?: boolean;
  routingDefaultMot?: GraphhopperRoutingProfile | null | RoutingMot;
} {
  const hideDidYouKnow =
    localStorage.getItem(LS_HIDE_DID_YOU_KNOW) === "true" ||
    sessionStorage.getItem(LS_HIDE_DID_YOU_KNOW) === "true";

  sessionStorage.setItem(LS_HIDE_DID_YOU_KNOW, "true");

  let exportQrCode: number | undefined = 0;
  const storageValue = localStorage.getItem(LS_EXPORT_QR_CODE);
  if (storageValue) {
    const parsedValue: boolean | number | undefined = JSON.parse(storageValue);
    if (parsedValue === true) {
      exportQrCode = undefined;
    }
    if (parsedValue === false) {
      exportQrCode = 0;
    }
  }

  return {
    dialogVisible: hideDidYouKnow ? false : DID_YOU_KNOW_DIALOG_NAME,
    exportBtnActive:
      localStorage.getItem(LS_EXPORT_BTN_ACTIVE) === "true" || undefined,
    exportFormat: localStorage.getItem(LS_EXPORT_FORMAT) || "image/png",
    exportQrCode,
    exportType: (localStorage.getItem(LS_EXPORT_TYPE) ||
      exportTypes[0]) as ExportType,
    geolocationActive:
      localStorage.getItem(LS_GEOLOCATION_ACTIVE) === "true" || undefined,
    routingDefaultMot: localStorage.getItem(LS_ROUTING_MOT) as
      | GraphhopperRoutingProfile
      | null
      | RoutingMot,
  };
}
